<template>
	<az-container class="fiscais mt-4">
		<az-toolbar class="interna az-toolbar">
			<template #actions v-if="totalItens">
				<botao-primario
					v-if="!isAtaCancelada"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					@click="abrirModalAdicionarFiscais"
					v-az-auth="permissoes.ataFiscaisCriar"
				>
				</botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por: nome ou órgão"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</template>
		</az-toolbar>

		<listagem-itens
			:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
			:colunas="getColunas()"
			:itens="datasource"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			@paginar="setPaginacao"
			@resetar-page="resetarPaginaListagem()"
			:tamanho-maximo-colunas="getTamanhoMaximoColunas()"
			show-actions
			listagem-vazia-custom
			listagem-vazia-custom-class="listagem-vazia"
		>
			<template #actions="{ item }">
				<listagem-fiscais-botoes-acoes
					@excluir="abrirOuFecharModalConfirmacaoExcluirFiscais(item)"
					:item="item"
					:is-ata-cancelada="isAtaCancelada"
				></listagem-fiscais-botoes-acoes>
			</template>
			<template #acoes-listagem-vazia>
				<botao-primario
					v-if="!isAtaCancelada"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					@click="abrirModalAdicionarFiscais"
					v-az-auth="permissoes.ataFiscaisCriar"
				>
				</botao-primario>
			</template>
		</listagem-itens>

		<modal-adicionar-fiscais
			v-if="exibirModalAdicionarFiscais"
			:exibir="exibirModalAdicionarFiscais"
			@fechar-modal="fecharModalAdicionarFiscais"
		>
		</modal-adicionar-fiscais>

		<modal-confirmacao
			:exibir="exibirModalConfirmacaoExcluirFiscais"
			titulo-modal="Excluir!"
			subtitulo-modal="Deseja excluir este fiscal?"
			mensagem="O fiscal excluído não poderá ser recuperado!"
			@fechar-modal="abrirOuFecharModalConfirmacaoExcluirFiscais"
			@confirmar="excluirFiscal"
		></modal-confirmacao>
	</az-container>
</template>
<script>
import BotaoPrimario from '@/views/components/BotaoPrimario'
import ModalAdicionarFiscais from '@/views/pages/ata/acessar/fiscais/adicionar/ModalAdicionarFiscais'
import ListagemItens from '@/views/components/ListagemItens'
import { TabelaColunaUtils } from '@/core/utils'
import formatDataFilter from '@/views/filters/format-data-filter'
import { actionTypes, permissoes, situacoes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import ListagemFiscaisBotoesAcoes from '@/views/pages/ata/acessar/fiscais/acoes/ListagemFiscaisBotoesAcoes.vue'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import { mapState } from 'vuex'

export default {
	name: 'fiscais-view',
	components: { ModalConfirmacao, ListagemFiscaisBotoesAcoes, ListagemItens, ModalAdicionarFiscais, BotaoPrimario },
	mixins: [permissoesMixin],
	data() {
		return {
			idAta: this.$route.params.id,
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
			isComponenteAtivo: true,
			exibirModalAdicionarFiscais: false,
			exibirModalConfirmacaoExcluirFiscais: false,
			fiscalParaExcluir: null,
			filtro: {
				nomeFiscalOuNomeOrgaoOuSiglaOrgao: {
					default: null,
					label: 'Pesquisa',
					value: null,
				},
			},
		}
	},
	computed: {
		...mapState({
			infoAta: (state) => state.ata.informacoesAta,
		}),
		textosDaListagemVazia() {
			const textos = { titulo: 'A ata não possui fiscais cadastrados' }

			if (this.verificarPermissao(permissoes.ataFiscaisCriar) && !this.isAtaCancelada) {
				textos['mensagem'] = 'Clique no botão para adicionar'
			}

			return textos
		},
		isAtaCancelada() {
			return this.infoAta?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	async mounted() {
		await this.buscarFiscaisAta()
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
	},
	methods: {
		async buscarFiscaisAta() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ATA.FISCAIS.BUSCAR_FISCAIS_ATA,
				this.montarPayloadBuscarFiscaisAta(),
			)

			this.datasource = this.formatarItens(itens)
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		getColunas() {
			const cols = [
				new TabelaColunaUtils('Nome', 'nomeFiscal', '23%'),
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '10%'),
				new TabelaColunaUtils('Data Criação', 'dataCriacao', '10%'),
				new TabelaColunaUtils('Vigência', 'vigencia', '15%'),
				new TabelaColunaUtils('Situação', 'situacao', '24%'),
			]

			if (this.verificarPermissao(this.permissoes.ataFiscaisExcluir)) {
				cols.push(new TabelaColunaUtils('Ações', 'actions', '5%'))
			}

			return cols
		},
		getTamanhoMaximoColunas() {
			return {
				nomeFiscal: 55,
				siglaOrgao: 20,
				dataCriacao: 15,
				vigencia: 30,
				situacao: 15,
			}
		},
		formatarItens(itens) {
			return itens.map((item) => {
				return {
					...item,
					vigencia: `${formatDataFilter(item.inicioVigencia)} - ${formatDataFilter(item.fimVigencia)}`,
					dataCriacao: `${formatDataFilter(item.dataCriacao)}`,
				}
			})
		},
		buscar(searchText) {
			if (searchText) {
				this.filtro.nomeFiscalOuNomeOrgaoOuSiglaOrgao.value = searchText.trim()
			}
			this.resetarPaginaListagem()
		},
		removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			this.resetarPaginaListagem()
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarFiscaisAta()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarFiscaisAta()
		},
		montarPayloadBuscarFiscaisAta() {
			return {
				filtro: { ...this.filtro, idAta: { value: this.idAta } },
				paginacao: this.paginacao,
			}
		},
		abrirModalAdicionarFiscais() {
			this.exibirModalAdicionarFiscais = true
		},
		fecharModalAdicionarFiscais() {
			this.exibirModalAdicionarFiscais = false
			this.buscarFiscaisAta()
		},
		async excluirFiscal() {
			await this.$store
				.dispatch(actionTypes.ATA.FISCAIS.EXCLUIR_FISCAL_ATA, this.fiscalParaExcluir.id)
				.then(() => this.mostrarNotificacaoSucessoDefault())

			this.abrirOuFecharModalConfirmacaoExcluirFiscais()
			await this.resetarPaginaListagem()
		},
		abrirOuFecharModalConfirmacaoExcluirFiscais(fiscal) {
			this.fiscalParaExcluir = fiscal
			this.exibirModalConfirmacaoExcluirFiscais = !this.exibirModalConfirmacaoExcluirFiscais
		},
	},
}
</script>
<style lang="stylus">
.fiscais

	.listagem-vazia
		padding 0.5rem 1.5rem
		margin 1.25rem

	.interna
		background-color white !important
		border none !important

	.az-toolbar
		height auto !important

	.az-toolbar .actions
		padding 0 !important

	.icon-search
		margin-right 0 !important
</style>
